<template>
  <div class="hero">
    <img src="../assets/sticker.png" class="sticker">
    <div id="social">
      <a href="mailto:info@degeneratebaker.com">
        <font-awesome-icon icon="envelope"/>
      </a>
      <a href="https://www.instagram.com/thedegeneratebaker/">
        <font-awesome-icon :icon="['fab', 'instagram']"/>
      </a>
      <a href="https://www.facebook.com/degeneratebaker/">
        <font-awesome-icon :icon="['fab', 'facebook-square']"/>
      </a>
    </div>
    <router-link class="pure-button button-xlarge" id="order-button" :to="{ name: 'orderForm' }">
      <font-awesome-icon icon="utensils-alt"/>&nbsp; Order a Custom Bake
    </router-link>
    <a class="pure-button button-large" id="vip-button" @click.prevent="scrollToFooter">
      <font-awesome-icon icon="envelope"/>&nbsp; Join VIP List
    </a>
    <div class="hero-content">
      <div class="baker"></div>
      <div class="logo"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hero',
  methods: {
    scrollToFooter() {
      window.scrollTo(0, document.body.scrollHeight)
    }
  }
}
</script>

<style lang="less" scoped>
.hero {
  background-color: #e7f6f8bb;

  .sticker {
    display: none;
  }

  #order-button {
    position: absolute;
    left: calc(50% + 140px);
    top: 480px;
  }

  #vip-button {
    position: absolute;
    left: calc(50% + 190px);
    top: 538px;
  }

  #social {
    margin-top: 0.5em;
    position: absolute;
    right: 1em;
    width: calc(100% - 2em);
    text-align: right;

    a {
      color: #497682;
      font-size: 2em;

      &:first-child {
        float: left;
      }

      &:last-child {
        margin-left: 0.25em;
      }
    }
  }

  .hero-content {
    height: 600px;
    margin: auto;
    max-width: 1024px;

    .baker {
      background-image: url('../assets/baker.png');
      background-position: center bottom;
      background-repeat: no-repeat;
      background-size: 90% auto;
      display: inline-block;
      height: 600px;
      width: 50%;
    }

    .logo {
      background-image: url('../assets/logo.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 90% auto;
      float: right;
      height: 600px;
      width: 50%;
    }
  }
}

@media (max-width: 1024px) {
  .hero {
    #order-button,
    #vip-button {
      display: none;
    }

    .sticker {
      display: block;
      left: calc(50% + 120px);
      position: absolute;
      margin-top: 120px;
      width: 120px;
    }

    .hero-content {
      height: 600px;

      .baker {
        background-size: auto 100%;
        float: right;
        width: 100%;
      }

      .logo {
        display: none;
      }
    }
  }
}

@media (max-width: 720px) {
  .hero {
    .sticker {
      left: calc(50% + 75px);
      margin-top: 50px;
      width: 120px;
    }
  }
}

@media (max-width: 480px) {
  .hero {
    .sticker {
      left: calc(50% + 75px);
      margin-top: 120px;
      width: 120px;
    }
  }
}

@media (max-width: 380px) {
  .hero {
    .sticker {
      left: calc(50% + 50px);
      margin-top: 180px;
      width: 100px;
    }
  }
}
</style>
